import React from "react";
import CountUp from "react-countup";
import Link from "next/link";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import styles from "./hero.module.scss";

export const UniPageProcessHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={12} md={6}>
            <h1 className={styles.title}>
              Combining Regional Market Experience with Smart Data-Driven
              Technology
            </h1>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/process_hero.png")}
                alt="Process"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageProcessHero;
